var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUploadOff = function SvgUploadOff(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.85v2.3l-2-2-1.575-1.575L11.3 4.7q.15-.15.325-.213.175-.062.375-.062t.375.062a.9.9 0 0 1 .325.213l3.6 3.6q.3.3.287.7-.012.4-.287.7-.3.3-.713.313a.93.93 0 0 1-.712-.288zM11 11l2 2v2q0 .424-.287.713A.97.97 0 0 1 12 16a.97.97 0 0 1-.713-.287A.97.97 0 0 1 11 15zm6.15 9H6q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 18v-2q0-.424.288-.713A.97.97 0 0 1 5 15q.424 0 .713.287Q6 15.576 6 16v2h9.15L2.075 4.925q-.3-.3-.3-.713 0-.412.3-.712t.713-.3.712.3l17 17q.3.3.3.7t-.3.7-.712.3a.97.97 0 0 1-.713-.3zM20 17.15l-1.775-1.775q.125-.15.313-.262A.9.9 0 0 1 19 15q.424 0 .712.287.288.288.288.713z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUploadOff);
export { ForwardRef as ReactComponent };